module.exports = __webpack_public_path__ + "img/waiting.cae15f5b.svg";